import { Children, FC, isValidElement } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import Box from "../../layout/boxes/Box";
import SelectOption from "./SelectOption";
import TextInputContainer from "../TextInputContainer/TextInputContainer";
import { SelectProps, SelectSubComponents } from "./Select.types";
import { StyledSelect, StyledSelectIcon } from "./styling/Select.styles";
import { resolvePaletteRoleForegroundToken } from "../../../functions/resolvePaletteRoleForegroundToken";
import { IconColorVariantOptions } from "../../imagery/Icon/Icon.types";

const Select: FC<SelectProps> & SelectSubComponents = ({
	children,
	className,
	colorOn,
	label,
	...props
}) => {
	const block = new BemIt("Select");

	const selectOptions = Children.map(children, (child) => {
		if (isValidElement(child)) {
			const isOption = child.type === SelectOption;

			if (!isOption) {
				console.error(
					`Invalid Select subcomponent: The child you provided is not a valid Select subcomponent, please provide Select.Option subcomponents`
				);
				return null;
			}

			return child;
		}
	});

	const hasLabel = Boolean(label);
	const iconColor = resolvePaletteRoleForegroundToken(colorOn).slice(
		3
	) as IconColorVariantOptions;

	return (
		<Box position="relative">
			<TextInputContainer
				className={addClass(className).after(block)}
				label={label}
				colorOn={colorOn}
				showFocusedLabel
				{...props}
			>
				<StyledSelect colorOn={colorOn} {...props}>
					{selectOptions}
				</StyledSelect>
			</TextInputContainer>
			<StyledSelectIcon
				className={block.el("icon").out}
				name="chevron-down"
				size="md"
				color={iconColor}
				hasLabel={hasLabel}
			/>
		</Box>
	);
};

Select.Option = SelectOption;

export default Select;
